import React from "react";
import { Link } from "react-router-dom";
import cn from "classnames";

const BreadcrumbArea = ({
  title,
  subtitle,
  showShape = true,
  className,
  showShapeThree,
  homeLabel = "Home", // optioneel, voor vertaling
}) => {
  return (
    <section className={cn("breadcrumb-area", className)}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb-content">
              <h2 className="title">{title}</h2>

              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{homeLabel}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {subtitle}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {showShape && (
        <div className="breadcrumb-shape-wrap" aria-hidden="true">
          <img
            src="/img/images/breadcrumb_shape01.png"
            alt="Decoratieve vorm element 1"
            role="presentation"
          />
          <img
            src="/img/images/breadcrumb_shape02.png"
            alt="Decoratieve vorm element 2"
            role="presentation"
          />
        </div>
      )}

      {showShapeThree && (
        <div className="breadcrumb-shape-wrap-three" aria-hidden="true">
          <img
            src="/img/images/breadcrumb_shape04.png"
            alt="Decoratieve vorm element 4"
            className="wow zoomIn"
            data-wow-delay=".2s"
            role="presentation"
          />
          <img
            src="/img/images/breadcrumb_shape05.png"
            alt="Decoratieve vorm element 5"
            className="wow zoomIn"
            data-wow-delay=".2s"
            role="presentation"
          />
          <img
            src="/img/images/breadcrumb_shape06.png"
            alt="Decoratieve vorm element 6"
            className="wow zoomIn"
            data-wow-delay=".2s"
            role="presentation"
          />
        </div>
      )}
    </section>
  );
};

export default BreadcrumbArea;
